import React, { Component } from 'react';
import PropTypes from 'prop-types';
import iconLocation from '../../images/icons/icon_32_location.png';
import { withTranslation } from 'react-i18next';

class MeetingPoints extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { meetingPoints, t } = this.props;
    return (
      meetingPoints.length > 0 ?
        <section className="fe-trip-map">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <h4 className="fe-trip-main-heading">{t('trip:availMeetingPoints')}</h4>
                <div className="fe-trip-meeting-points">
                  {meetingPoints.map((mp) => (
                    <div key={mp.id} className="fe-trip-meeting-point-container">
                      <div className="fe-trip-map-details">
                        <h5 className="fe-trip-map-place">
                          <img src={iconLocation} alt=""/>
                          {mp.place_name}
                        </h5>
                        <p
                          className="fe-trip-map-address"
                          dangerouslySetInnerHTML={{__html: mp.address}}
                        />
                        <p className="fe-trip-map-contact">
                          {mp.phone_number}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section> : 
        null
    );
  }
}

MeetingPoints.propTypes = {
  meetingPoints: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MeetingPoints);